export const VALID_EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function isEmail(email: string): boolean {
  return VALID_EMAIL_REGEX.test(email);
}

export function replaceRange(
  string: string,
  replacement: string,
  start: number,
  end?: number
): string {
  return (
    string.substring(0, start) + replacement + string.substring(end ?? start)
  );
}
